import React from 'react';
import { VoidFn } from 'types/baseTypes';

interface RadioWithLabelProps {
  isSelected: boolean;
  label: string | React.ReactNode;
  onClick: VoidFn;
  labelStyle?: object;
  radioPosition?: 'left' | 'right';
  disabled?: boolean;
  containerClassname?: string;
}

const RadioWithLabel: React.FC<RadioWithLabelProps> = ({
  isSelected,
  label,
  onClick,
  labelStyle,
  radioPosition = 'left',
  disabled = false,
  containerClassname = ''
}) => {
  const RadioButton = (
    <div
      className={`flex h-[18px] w-[18px] items-center justify-center rounded-full border-[1.5px] border-border ${
        disabled ? 'opacity-50' : ''
      }`}>
      <div className={`h-2.5 w-2.5 rounded-full ${isSelected ? 'bg-secondary' : 'bg-highlightGray'} `} />
    </div>
  );

  const Label = (
    <div className="text-sbase text-primaryText" style={labelStyle}>
      {label}
    </div>
  );

  return (
    <div
      className={`${containerClassname} flex cursor-pointer items-center gap-2.5 ${
        disabled ? 'pointer-events-none' : ''
      }`}
      onClick={onClick}>
      {radioPosition === 'left' ? (
        <>
          {RadioButton}
          {Label}
        </>
      ) : (
        <>
          {Label}
          {RadioButton}
        </>
      )}
    </div>
  );
};

export default RadioWithLabel;
